import React, { useState, useEffect } from 'react';
import { moduleClientFactory } from '../api-service/module-client-factory';
import { GetTenantConfigurationResponse } from '../api-service/clients/auto-generated-clients';

const TenantConfigurationContext = React.createContext({} as GetTenantConfigurationResponse);

type TenantConfigurationProviderProps = {
  children: React.ReactNode;
};

export function TenantConfigurationProvider({ children }: TenantConfigurationProviderProps) {
  const [tenantConfiguration, setTenantConfiguration] = useState<GetTenantConfigurationResponse>({ crmUrl: '', tenantDisplayName: '' });

  useEffect(() => {
    const getTenantConfiguration = async () => {
      const configurationClient = moduleClientFactory.createConfigurationClient();
      const tenantConfigurationResult = await configurationClient.getTenantConfiguration();
      setTenantConfiguration(tenantConfigurationResult || { crmUrl: '', tenantDisplayName: '' });
    };
    getTenantConfiguration();
  }, []);

  return <TenantConfigurationContext.Provider value={tenantConfiguration}>{children}</TenantConfigurationContext.Provider>;
}

export const useTenantConfiguration = (): GetTenantConfigurationResponse => React.useContext(TenantConfigurationContext);
